/**
* @Author: Dmytro Mykhailov <dmitriymikhaylov>
* @Date:   2016-10-02T09:11:25+03:00
* @Email:  belindream@gmail.com
* @Project: Lumand
* @Last modified by:   dmitriymikhaylov
* @Last modified time: 2016-10-17T21:27:24+03:00
* @License: MIT
*/



import React, { Component } from 'react'
import AttachmentRender from './AttachmentRender'
import * as R from 'ramda'
export default class EntityAttachments extends Component {
	constructor(props){
		super(props)
		this.state={
			inputKey: 0
		}
	}
	render(){
		let attachmentsIDsHolder = this.props.attHolder || "attachmentsIDs"
		return(
			<div style={{
				}}>
				<div style={{position: "relative"}}>
					<div
						className="entity-attachments"
						style={{
							height: (this.props.attachmentsIDs)?"auto":"32px !important"
						}}
					>
						{
							(this.props.attachmentsIDs)?
								R.map((attInfo)=>{
									return(
									((this.props.attachments && this.props.attachments[attInfo.id]) || (attInfo.href))?
										<AttachmentRender
											style={{
												overflow: 'hidden'
											  , display: 'inline-block'
											  , textAlign: 'left'
											  , margin: '0 5px'
											  , verticalAlign: 'top'
											}}
											key={attInfo.id}
											attachmentStyle={{
												maxWidth: '150px'
											  , maxHeight:'70px'
											  , display: 'inline-block'
											  , margin: 'auto'
											  , cursor: 'pointer'
											}}
											className="attachment-render"
											file={(!attInfo.href)? this.props.attachments[attInfo.id].data: false}
											link={attInfo.href}
											name={attInfo.name}
											onClick={()=> {
												this.props.openAttachment({
													file: (this.props.attachments && this.props.attachments[attInfo.id])?
														this.props.attachments[attInfo.id].data
															: false
												  , name: attInfo.name
												  , href: attInfo.href
												});
												return false
											}}
											deleteFunction={()=>{
												this.props.docUpd({
													_id: this.props.id
												  , _attachments: (attInfo.id)? R.dissoc(attInfo.id.toString(), this.props.attachments) : this.props.attachments
												  , [attachmentsIDsHolder]: R.reject(att => (!attInfo.href)? att.id == attInfo.id : att.href == attInfo.href, this.props.attachmentsIDs)
												})
}
											}
											thumb={true}
										/>
									: "Loading"
								)}, this.props.attachmentsIDs)
								:""
						}
						<input
							type="file"
							style={{
								display: "none"

							}}
							key={this.state.inputKey}
							id="fileInp"
							onChange={(evt) =>{
								let attID = new Date().valueOf()
								if(evt.target.files[0]){
									this.props.docUpd({
										_id: this.props.id
									  , _attachments: {
											...this.props.attachments
										  , [attID]:{
												data: evt.target.files[0]
											  , content_type: evt.target.files[0].type
											}
										}
									  , [attachmentsIDsHolder]: (this.props.attachmentsIDs)?
											[
												...this.props.attachmentsIDs
											  , {
													id: attID
												  , name: evt.target.files[0].name
												}
											]
											: [{
												id: attID
											  , name: evt.target.files[0].name
											}]
									})
									this.setState({
										inputKey: this.state.inputKey + 1
									})
								}
							}}
							// ref="choose-attachment"
						/>
						<br/>
						<div
							style={{
								height: "30pt"
							  , borderRadius: "4px"
							  , lineHeight: "30pt"
							  , display: "inline-block"
							  , padding: "0 10pt"
							  , backgroundColor: "#fff"
							  , cursor: (this.props.disabled)? "default" : "pointer"
							  , clear: "both"
							  , position: "relative"
							  , top: (this.props.attachmentsIDs)?"auto":"-48px !important"
							}}
							onClick={()=>{
								if(!this.props.disabled){
									// this.refs["choose-attachment"].click()
								}
							}}
							title={(this.props.disabled)? this.props.disabledText: ""}
						>
							<img
								style={{
									verticalAlign: "middle"
								  , height: "10pt"
								  , marginRight: "5px"
								}}
								src={(this.props.disabled)? '/' + process.env.REACT_APP_NAME + "/static/img/attachments_gray.png" : '/' + process.env.REACT_APP_NAME + "/static/img/attachments.png"}
							/>
							<span
								style={{
									verticalAlign: "middle"
								  , fontSize: "10pt"
								  , color: (this.props.disabled)? "gray" : "#3cd2ae"
								  , borderBottom: (this.props.disabled)? "2px dotted gray" : "2px dotted #3cd2ae"
								}}
							>
								ATTACH
							</span>
						</div>
					</div>
				</div>
			</div>
		)
	}
}







// export default class EntityAttachments extends Component {
// 	render(){
// 		let attachmentsIDsHolder = this.props.attHolder || "attachmentsIDs"
// 		return(
// 			<div style={{
// 				backgroundColor: "#f5f5f5",
// 				marginTop: "-10px",
// 				marginBottom: "-16px",
// 				marginLeft: "-20px",
// 				border: "2px solid #3cd2ae",
// 				borderRadius: "4px"
// 				}}>
// 				<div style={{position: "relative", left: "20px", top: "16px"}}>
// 					<span style={{fontWeight: "bold", fontSize: "11px", color: "#959595"}}>Attached files:</span>
// 					<div
// 						className="entity-attachments"
// 						style={{
// 							marginTop: '10px'
// 						  , marginBottom: '10px'
// 						}}
// 					>
// 						{
// 							(this.props.attachmentsIDs)?
// 								R.map((attInfo)=>{
// 									return(
// 									((this.props.attachments && this.props.attachments[attInfo.id]) || (this.props.attachmentsHrefs && this.props.attachmentsHrefs[attInfo.id]))?
// 										<AttachmentRender
// 											style={{
// 												overflow: 'hidden'
// 											  , display: 'inline-block'
// 											  , textAlign: 'left'
// 											  , margin: '0 5px'
// 											  , verticalAlign: 'top'
// 											}}
// 											key={attInfo.id}
// 											attachmentStyle={{
// 												maxWidth: '150px'
// 											  , maxHeight:'70px'
// 											  , display: 'inline-block'
// 											  , margin: 'auto'
// 											  , cursor: 'pointer'
// 											}}
// 											className="attachment-render"
// 											file={(!this.props.attachmentsHrefs || !this.props.attachmentsHrefs[attInfo.id])? this.props.attachments[attInfo.id].data: false}
// 											to={(this.props.attachmentsHrefs && this.props.attachmentsHrefs[attInfo.id])? this.props.attachmentsHrefs[attInfo.id]: false}
// 											name={attInfo.name}
// 											onClick={()=> {
// 												this.props.openAttachment({file: this.props.attachments[attInfo.id].data, name: attInfo.name});
// 												return false
// 											}}
// 											deleteFunction={()=>
// 												this.props.docUpd({
// 													_id: this.props.id
// 												  , _attachments: R.dissoc(R.prop(attInfo.id), this.props.attachments)
// 												  , attachmentsIDs: R.reject(att => att.id == attInfo.id, this.props.attachmentsIDs)
// 												})
//
// 											}
// 											thumb={true}
// 										/>
// 									: "Loading"
// 								)}, this.props.attachmentsIDs)
// 								:""
// 						}
// 						<input
// 							type="file"
// 							style={{
// 								display: "none"
//
// 							}}
// 							id="fileInp"
// 							onChange={(evt) =>{
// 								let attID = new Date().valueOf()
// 								if(evt.target.files[0]){
// 									this.props.docUpd({
// 										_id: this.props.id
// 									  , _attachments: {
// 											...this.props.attachments
// 										  , [attID]:{
// 												data: evt.target.files[0]
// 											  , content_type: evt.target.files[0].type
// 											}
// 										}
// 									  , [attachmentsIDsHolder]: (this.props.attachmentsIDs)?
// 											[
// 												...this.props.attachmentsIDs
// 											  , {
// 													id: attID
// 												  , name: evt.target.files[0].name
// 												}
// 											]
// 											: [{
// 												id: attID
// 											  , name: evt.target.files[0].name
// 											}]
// 									})
// 								}
// 							}}
// 							ref="choose-attachment"
// 						/>
// 						<br/>
// 						<div onClick={()=> this.refs["choose-attachment"].click()}
// 							style={{
// 								height: "30pt"
// 							  , margin: "5pt 0"
// 							  , border: "1px solid #3cd2ae"
// 							  , borderRadius: "4px"
// 							  , lineHeight: "30pt"
// 							  , display: "inline-block"
// 							  , padding: "0 10pt"
// 							  , backgroundColor: "#3cd2ae"
// 							  , cursor: "pointer"
// 							  , clear: "both"
// 							  , marginBottom: "24px"
// 							}}
// 							onClick={()=> this.refs["choose-attachment"].click()}
// 						>
// 							<img
// 								style={{
// 									verticalAlign: "middle"
// 								  , height: "10pt"
// 								}}
// 								src={'/' + process.env.REACT_APP_NAME + "/static/img/attachments-white.png"}
// 							/>
// 							<span
// 								style={{
// 									verticalAlign: "middle"
// 								  , fontSize: "10pt"
// 								  , color: "#fff"
// 								}}
// 							>
// 								ADD FILE
// 							</span>
// 						</div>
// 					</div>
// 				</div>
// 			</div>
// 		)
// 	}
// }



// WEBPACK FOOTER //
// ./src/components/EntityAttachments.js